/* this file is transformed by vux-loader */
/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isAuth: 0,
    // 是否登录(-1：未登陆，0：登陆中……，1：已登陆)
    account: {},
    // 用户信息
    userInfo: null,
    // 用户信息
    // register: 0,       // 是否注册
    login: false // 是否已登录

  },
  mutations: {
    // 改变用户信息
    changeAccount: function changeAccount(state, account) {
      if (account === null) {
        state.isAuth = -1;
        state.account = {};
      } else {
        state.isAuth = 1;
        state.account = account.user;
      }
    },
    //记录用户信息
    recordUserInfo: function recordUserInfo(state, payload) {
      state.login = true;
      state.userInfo = payload.userInfo;
    },
    //更新注册状态
    updateLogin: function updateLogin(state, payload) {
      state.login = payload.login;
    }
  },
  actions: {
    //更改权限信息
    changeAccess: function changeAccess(_ref, params) {
      var commit = _ref.commit;
      commit('updateLogin', {
        login: params.login
      });
      commit('recordUserInfo', {
        userInfo: params.userInfo
      });
    }
  }
});